// ── Márkaoldalak tartalma – EGY forrás ──────────────────────────────────────
//
// A használt-készlet márkaoldalai (/hasznalt-<márka>-telefon-oroshaza) ebből
// a fájlból épülnek. A cél NEM az, hogy öt majdnem azonos oldal legyen öt
// márkanévvel – ezért minden márka kap:
//   • saját bevezetőt,
//   • 3 VALÓS, márkára jellemző tényt (nem marketinget),
//   • 2 márkaspecifikus GYIK-et, ami tényleg csak arra a márkára igaz,
//   • saját szerviz-hivatkozást.
// A készlet maga (ami márkánként más és folyamatosan változik) adja a
// tartalom többi részét.
//
// SZABÁLY: ide csak olyan állítás kerülhet, ami IGAZ és ellenőrizhető.
// Árat, alkatrész-elérhetőséget, szolgáltatást kitalálni tilos – ahol nincs
// adatunk (Honor/Huawei alkatrészár), ott a szöveg ezt ki is mondja.

export const MARKA_OLDALAK = [
  {
    kulcs: 'iPhone',
    slug: 'hasznalt-iphone-oroshaza',
    cim: 'Használt iPhone Orosházán – garanciával, bevizsgálva | NorbiPhone',
    leiras: 'Bevizsgált, garanciás használt iPhone Orosházán. Megmutatjuk az akkumulátor állapotát, 3 hónap szervizgarancia, személyes átvétel. Régi készüléked beszámítjuk.',
    h1: 'Használt iPhone Orosházán',
    bevezeto: 'Minden iPhone-t a saját szervizünkben vizsgálunk át, és az akkumulátor állapotát számszerűen megmutatjuk, mielőtt döntenél. Nem kell postát várni: a készülék itt van az üzletben, kipróbálhatod.',
    tenyek: [
      'Az iPhone maga méri az akkumulátor maximális kapacitását – ezt a Beállítások → Akkumulátor menüben te is ellenőrizheted átvétel előtt.',
      'Minden általunk eladott iPhone le van választva az előző tulajdonos iCloud-fiókjáról. Aktiválási zárral készüléket nem adunk el.',
      'Ha az akkumulátor idővel elfárad, van rá tételes árlistánk: az iPhone akkumulátorcsere 20 000 Ft-tól indul.',
    ],
    gyik: [
      {
        q: 'Honnan tudom, hogy nem lopott a készülék?',
        a: 'Minden felvásárolt készüléket ellenőrzünk, és a bejelentett, elveszett vagy ellopott telefonokat belső figyelőlistán tartjuk. Az eladónak személyazonosító okmányt kell bemutatnia, a vásárlásról papír készül.',
      },
      {
        q: 'Kapok garanciát használt iPhone-ra?',
        a: '3 hónap szervizgaranciát adunk minden általunk eladott használt készülékre. Ha ezen belül hiba jelentkezik, hozd vissza – a javítás a mi dolgunk.',
      },
    ],
    szerviz: { cim: 'iPhone szerviz Orosházán', url: '/iphone-szerviz-oroshaza/' },
  },
  {
    kulcs: 'Samsung',
    slug: 'hasznalt-samsung-telefon-oroshaza',
    cim: 'Használt Samsung telefon Orosházán – garanciával | NorbiPhone',
    leiras: 'Bevizsgált, garanciás használt Samsung Galaxy készülékek Orosházán. Kijelző, kamera, töltés és akku ellenőrizve, 3 hónap szervizgarancia, személyes átvétel.',
    h1: 'Használt Samsung telefon Orosházán',
    bevezeto: 'Galaxy S és A szériás készülékek a készletünkből, mind bevizsgálva. A kijelzőt, a kamerát, a töltést és az akkut is ellenőrizzük, mielőtt a polcra kerül.',
    tenyek: [
      'A Galaxy S széria a csúcskategória, az A széria a megfizethetőbb vonal – ugyanattól a gyártótól, ugyanazzal a szoftverrel. Ha nem tudod, melyik kell, megmutatjuk egymás mellett.',
      'Minden Samsungról letöröljük az előző tulajdonos Google- és Samsung-fiókját. Fiókzárral (FRP) készüléket nem adunk el.',
      'A Samsung kijelzőcserének külön oldala van nálunk, tételes információval – a használt készülék mellé is jó tudni, mennyibe kerülne.',
    ],
    gyik: [
      {
        q: 'Mennyire lassul be egy használt Samsung?',
        a: 'A Samsung a legtöbb újabb Galaxyhoz több éven át ad szoftverfrissítést. Átvétel előtt megmutatjuk, hogy a konkrét készülék milyen Android-verzión fut, és kap-e még frissítést.',
      },
      {
        q: 'Beszámítjátok a régi telefonomat Samsungra?',
        a: 'Igen. A kalkulátorban percek alatt kiszámolod, mennyit ér a régi készüléked, és az összeget beszámítjuk a használt Samsung árába.',
      },
    ],
    szerviz: { cim: 'Samsung szerviz Orosházán', url: '/samsung-szerviz-oroshaza/' },
  },
  {
    kulcs: 'Xiaomi',
    slug: 'hasznalt-xiaomi-telefon-oroshaza',
    cim: 'Használt Xiaomi telefon Orosházán – garanciával | NorbiPhone',
    leiras: 'Bevizsgált, garanciás használt Xiaomi, Redmi és POCO készülékek Orosházán. 3 hónap szervizgarancia, személyes átvétel, régi telefon beszámításával.',
    h1: 'Használt Xiaomi telefon Orosházán',
    bevezeto: 'Xiaomi, Redmi és POCO készülékek a készletünkből – ugyanazzal a bevizsgálással és garanciával, mint minden más márka nálunk.',
    tenyek: [
      'A Redmi és a POCO a Xiaomi saját almárkái: ugyanaz a gyártó áll mögöttük. Ha Redmi vagy POCO készüléket keresel, jó helyen jársz.',
      'A Xiaomi telefonokon Google Play van, tehát minden megszokott alkalmazás elérhető rajtuk.',
      'A Xiaomi akkumulátorcserét a Samsung–Xiaomi akkumulátorcsere oldalunkon részletezzük.',
    ],
    gyik: [
      {
        q: 'Mi a különbség a Xiaomi, a Redmi és a POCO között?',
        a: 'Mindhárom a Xiaomi márkacsaládja. A Xiaomi a fő vonal, a Redmi a megfizethető kategória, a POCO pedig jellemzően erős hardvert ad alacsonyabb áron. A szervizük és az alkatrészeik nagyrészt közösek.',
      },
      {
        q: 'Kapok hozzá garanciát?',
        a: '3 hónap szervizgaranciát adunk rá, ugyanúgy, mint bármely más általunk eladott használt készülékre.',
      },
    ],
    szerviz: { cim: 'Xiaomi szerviz Orosházán', url: '/android-szerviz-oroshaza/' },
  },
  {
    kulcs: 'Honor',
    slug: 'hasznalt-honor-telefon-oroshaza',
    cim: 'Használt Honor telefon Orosházán – garanciával | NorbiPhone',
    leiras: 'Bevizsgált, garanciás használt Honor készülékek Orosházán. Kijelző, kamera, töltés és akkuállapot ellenőrizve, 3 hónap szervizgarancia, személyes átvétel.',
    h1: 'Használt Honor telefon Orosházán',
    bevezeto: 'Honor készülékek a készletünkből – bevizsgálva, garanciával, helyben kipróbálhatóan. A Honorral kapcsolatban a leggyakoribb kérdés a Google-szolgáltatásokra vonatkozik; erre lentebb válaszolunk.',
    tenyek: [
      'A Honor 2020 novembere óta önálló cég, nem a Huawei része. Az azóta megjelent Honor készülékeken ott a Google Play és minden Google-alkalmazás.',
      'A Honorra ugyanaz a 3 hónap szervizgarancia vonatkozik, mint a többi általunk eladott használt készülékre.',
      'Honor javítást is vállalunk. Tételes árlistánk erre a márkára nincs – a bevizsgálás ingyenes, és utána mondunk pontos árat.',
    ],
    gyik: [
      {
        q: 'Van Google Play a Honor telefonokon?',
        a: 'A 2020 végi különválás után megjelent Honor készülékeken igen, teljes Google-szolgáltatással. A korábbi, még Huawei alatt kiadott Honor modelleknél ez modellenként eltér – átvétel előtt együtt megnézzük a konkrét készüléken.',
      },
      {
        q: 'Meg tudjátok javítani, ha elromlik?',
        a: 'Megnézzük, és őszintén megmondjuk. A bevizsgálás ingyenes. Ha az adott alkatrészt nem tudjuk beszerezni, azt előre közöljük – nem kezdünk bele olyan javításba, amit nem tudunk befejezni.',
      },
    ],
    szerviz: { cim: 'Honor szerviz Orosházán', url: '/android-szerviz-oroshaza/' },
  },
  {
    kulcs: 'Huawei',
    slug: 'hasznalt-huawei-telefon-oroshaza',
    cim: 'Használt Huawei telefon Orosházán – garanciával | NorbiPhone',
    leiras: 'Bevizsgált, garanciás használt Huawei készülékek Orosházán. Megmondjuk, van-e rajta Google Play. 3 hónap szervizgarancia, személyes átvétel.',
    h1: 'Használt Huawei telefon Orosházán',
    bevezeto: 'Huawei készülékek a készletünkből – bevizsgálva, garanciával. A Huaweinél egy dolgot mindenképp tisztázunk átvétel előtt: a Google-szolgáltatások elérhetőségét. Ezt nem hallgatjuk el, mert utólag csalódás lenne.',
    tenyek: [
      'A 2019-es kereskedelmi korlátozás után megjelent Huawei modelleken NINCS Google Play. Helyette a Huawei saját AppGallery áruháza működik.',
      'A korábbi, 2019 előtti Huawei készülékeken a Google-szolgáltatások megvannak. Hogy a konkrét darabon mi a helyzet, azt átvétel előtt együtt megnézzük.',
      'Huawei javítást is vállalunk. Tételes árlistánk erre a márkára nincs – a bevizsgálás ingyenes, és utána mondunk pontos árat.',
    ],
    gyik: [
      {
        q: 'Működik a Google Play egy használt Huaweien?',
        a: 'Modelltől függ. A 2019-es korlátozás előtt kiadott készülékeken igen; az azután megjelenteken nincs Google Play, csak a Huawei AppGallery. Ha neked Google-alkalmazások kellenek (Gmail, Térkép, YouTube a megszokott módon), ezt átvétel előtt tisztázzuk.',
      },
      {
        q: 'Akkor miért érdemes mégis Huaweit venni?',
        a: 'A hardver jellemzően erős, a kamerák jók, és a korlátozás miatt az ár is kedvezőbb. Ha az AppGallery kínálata elég neked, jó vétel lehet. Ha nem, inkább más márkát ajánlunk – ezt őszintén megmondjuk.',
      },
    ],
    szerviz: { cim: 'Huawei szerviz Orosházán', url: '/android-szerviz-oroshaza/' },
  },
];

/** Slug → márkaoldal (vagy null). */
export const markaOldalSlugbol = (slug) =>
  MARKA_OLDALAK.find((m) => m.slug === slug) || null;

/** Kategória-kulcs → márkaoldal (vagy null). Ebből tudja a /telefonok szűrő,
 *  hogy van-e az adott márkának saját, tiszta URL-es oldala. */
export const markaOldalKulcsbol = (kulcs) =>
  MARKA_OLDALAK.find((m) => m.kulcs === kulcs) || null;

/** Az összes márkaoldal útvonala – sitemaphoz és prerenderhez. */
export const MARKA_OLDAL_UTVONALAK = MARKA_OLDALAK.map((m) => `/${m.slug}`);
